// Formats in UTC — Hydra's eligibility/renewal dates are UTC day boundaries
// (e.g. 23:59:59.999+0000), so local-time formatting shifts them a day ahead
// for any viewer east of UTC.
export function formatDate(date: string) {
  const d = new Date(date);
  let month = "" + (d.getUTCMonth() + 1),
    day = "" + d.getUTCDate();
  const year = d.getUTCFullYear();

  if (month.length < 2) {
    month = "0" + month;
  }
  if (day.length < 2) {
    day = "0" + day;
  }

  return [day, month, year].join(".");
}
